import React, { useMemo } from 'react'
import injectSheet from 'react-jss'
import styles from './action-comment-reply.styles'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'
import { distanceInWords } from 'date-fns'
import ContextMenu from './context-menu/context-menu.container'
import { withRouter } from 'react-router-dom'

const ActionCommentReply = ({
  classes,
  id,
  avatar,
  name,
  content,
  timestamp,
  contributionId,
  parentId,
  canDelete,
  edited
}) => {
  const postedAt = useMemo(
    () => (!timestamp ? '' : distanceInWords(new Date(), new Date(timestamp))),
    [timestamp]
  )

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <PobbleAvatar avatar={avatar} name={name} className={classes.avatar} />
        <div className={classes.content}>
          <div className={classes.action}>
            <strong className={classes.name}>{name}</strong> replied {postedAt}{' '}
            ago {edited && <span>(edited)</span>}
            {canDelete && (
              <div className={classes.dots}>
                <ContextMenu
                  id={id}
                  contributionId={contributionId}
                  parentId={parentId}
                  content={content}
                />
              </div>
            )}
          </div>
          <p>{content}</p>
        </div>
      </div>
    </div>
  )
}

export default withRouter(injectSheet(styles)(ActionCommentReply))
